/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicestatusuncollectible2Inputs */

const en_invoicestatusuncollectible2 = /** @type {(inputs: Invoicestatusuncollectible2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uncollectible`)
};

const de_invoicestatusuncollectible2 = /** @type {(inputs: Invoicestatusuncollectible2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht einbringbar`)
};

/**
* | output |
* | --- |
* | "Uncollectible" |
*
* @param {Invoicestatusuncollectible2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicestatusuncollectible2 = /** @type {((inputs?: Invoicestatusuncollectible2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicestatusuncollectible2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicestatusuncollectible2(inputs)
	return de_invoicestatusuncollectible2(inputs)
});
export { invoicestatusuncollectible2 as "invoiceStatusUncollectible" }